import React from 'react';
import { Collapse as AntCollapse, CollapseProps } from 'antd';
import cn from 'classnames';

import { AngleDownIcon } from '@revfluence/fresh-icons/solid';
import styles from './Collapse.module.scss';

export interface ICollapseProps extends CollapseProps {}

/**
 * A content area which can be collapsed and expanded.
 */
export const Collapse: React.FC<ICollapseProps> = ({
  className,
  expandIconPosition = 'end',
  ...restProps
}) => (
  <AntCollapse
    className={cn(styles.Collapse, className)}
    expandIconPosition={expandIconPosition}
    expandIcon={() => <AngleDownIcon />}
    {...restProps}
  />
);
